module.exports = __webpack_public_path__ + "static/img/banner-skdx.806638f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-skdx.png
// module id = a/jN
// module chunks = 1